import React, { useState, createContext, useContext, useEffect } from 'react'
import newsletterdata from '@/data/newsletters'

const defaultState = {
  dark: false,
  email: '',
  subscriptions: [],
  newsletters: newsletterdata,
  optin: '',
  canSubscribeToLT: false,
  canSubscribeToPC: false,
  triggerUnsubscribe: false,
}

const SiteContext = createContext(defaultState)

const useSiteContext = () => useContext(SiteContext)

const { Provider, Consumer } = SiteContext

const SiteProvider = ({ children }) => {
  const [dark, setDark] = useState(defaultState.dark)
  const [email, setEmail] = useState(defaultState.email)
  const [subscriptions, setSubscriptions] = useState(defaultState.subscriptions)
  const [newsletters, setNewsletters] = useState(defaultState.newsletters)
  const [optin, setOptin] = useState(defaultState.optin)
  const [canSubscribeToLT, setCanSubscribeToLT] = useState(
    defaultState.canSubscribeToLT,
  )
  const [canSubscribeToPC, setCanSubscribeToPC] = useState(
    defaultState.canSubscribeToPC,
  )
  const [triggerUnsubscribe, setTriggerUnsubscribe] = useState(
    defaultState.triggerUnsubscribe,
  )

  const toggleDark = () => {
    setDark(!dark)
  }

  const saveEmail = incomingEmail => {
    if (email !== incomingEmail) {
      setEmail(incomingEmail)
    }
  }

  const addSubscription = incomingSubscription => {
    console.log('addSubscription incoming', incomingSubscription)
    setSubscriptions([...subscriptions, incomingSubscription])
  }

  const addSubscriptions = incomingSubscriptions => {
    console.log('addSubscriptions incoming', incomingSubscriptions)
    setSubscriptions([...subscriptions, ...incomingSubscriptions])
  }

  const getSubscription = field => {
    return subscriptions.find(subscription => subscription.field === field)
  }

  const removeSubscription = incomingSubscription => {
    console.log('removeSubscription on sitecontext', incomingSubscription)
    setSubscriptions(
      subscriptions.filter(
        subscription => subscription.field !== incomingSubscription.field,
      ),
    )
  }

  const updateOptin = incomingOptin => {
    setOptin(incomingOptin)
  }

  const clearSubscriptions = () => {
    setSubscriptions([])
  }

  const context = {
    dark,
    email,
    subscriptions,
    newsletters,
    optin,
    canSubscribeToLT,
    canSubscribeToPC,
    triggerUnsubscribe,
    toggleDark,
    setOptin,
    updateOptin,
    saveEmail,
    setTriggerUnsubscribe,
    addSubscription,
    addSubscriptions,
    getSubscription,
    removeSubscription,
    clearSubscriptions,
    setCanSubscribeToLT,
    setCanSubscribeToPC,
  }

  return <Provider value={context}>{children}</Provider>
}

export default useSiteContext

export { SiteProvider, Consumer as SiteConsumer }
